import React, { useEffect, useState } from "react";
import axios from "axios";

const MonthlyRevenue = () => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const fetchMonthlyRevenue = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BASE_URL}/admin/analytics/revenue/monthly`
        );
        setData(res.data);
      } catch (error) {
      }
    };
    fetchMonthlyRevenue();
  }, []);

  return (
    <div className="widget">
      <h3>Monthly Revenue</h3>
      <ul>
        {data.length === 0 && <li>No data</li>}
        {data.map((item) => (
          <li key={item.month}>
            {item.month}: ₹{item.totalRevenue}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MonthlyRevenue;
